import { FunctionComponent } from "react";

const BackgroundElementText: FunctionComponent = () => {
  return (
    <div className="self-stretch flex flex-col items-start justify-start max-w-full text-center text-45xl text-gray-100 font-racing-sans-one">
      <div className="self-stretch bg-gray-500 flex flex-row items-center justify-center py-[55px] px-2.5 box-border max-w-full">
        <h1 className="m-0 h-[81px] flex-1 relative text-inherit font-normal font-inherit flex items-center justify-center max-w-full mq800:text-32xl mq450:text-19xl">
          Specials on New and Used Bikes!!!
        </h1>
      </div>
      <div className="self-stretch flex flex-col items-start justify-start py-2.5 px-0.5 box-border max-w-full text-black font-questrial">
        <div className="self-stretch flex flex-row flex-wrap items-start justify-between py-0 px-10 box-border min-h-[1095px] gap-[20px] max-w-full">
          <div className="w-[593px] flex flex-col items-start justify-start gap-[5px] max-w-full">
            <img
              className="self-stretch h-[371px] relative max-w-full overflow-hidden shrink-0 object-cover"
              loading="eager"
              alt=""
              src="/robert@2x.png"
            />
            <h1 className="m-0 self-stretch h-[66px] relative text-inherit font-normal font-inherit flex items-center justify-center mq800:text-32xl mq450:text-19xl">
              Robet Bye
            </h1>
          </div>
          <div className="w-[649px] flex flex-col items-start justify-start gap-[5px] max-w-full">
            <img
              className="w-[590px] h-[367px] relative object-cover max-w-full"
              loading="eager"
              alt=""
              src="/mikkel@2x.png"
            />
            <h1 className="m-0 self-stretch h-[66px] relative text-inherit font-normal font-inherit flex items-center justify-center mq800:text-32xl mq450:text-19xl">
              Mikkel Bech
            </h1>
          </div>
          <div className="w-[593px] flex flex-col items-start justify-start gap-[5px] max-w-full">
            <img
              className="self-stretch h-[346px] relative max-w-full overflow-hidden shrink-0 object-cover"
              alt=""
              src="/vaccinium@2x.png"
            />
            <h1 className="m-0 self-stretch h-[66px] relative text-inherit font-normal font-inherit flex items-center justify-center mq800:text-32xl mq450:text-19xl">
              Dmitrii Vaccinium
            </h1>
          </div>
          <div className="w-[585px] flex flex-row items-start justify-between py-0 px-10 box-border max-w-full text-5xl">
            <div className="h-[500px] flex-1 relative flex items-center max-w-full mq450:text-lgi">
              <span>
                <p className="m-0">
                  Lorem ipsum dolor sit amet consectetur. Elementum a ut risus
                  pharetra lorem. Eleifend enim faucibus praesent in molestie
                  quam. Urna quam et ornare purus ac sed eleifend. Nullam sociis
                  sollicitudin vitae molestie fringilla. Nec lobortis tincidunt
                  orci eget est varius convallis imperdiet. Ultrices risus sit
                  in senectus. Volutpat scelerisque nisl est neque. Vitae
                  rhoncus sed ut amet augue imperdiet mauris elementum nulla.
                  Turpis morbi eros eget mollis.
                </p>
                <p className="m-0">&nbsp;</p>
                <p className="m-0">{`Blandit quisque diam tellus rhoncus tellus. Eros risus pellentesque et nulla nunc enim massa pulvinar. Sagittis vestibulum sed est nisl et varius penatibus. A id diam sed nulla ullamcorper leo a pretium eget. Nulla lorem ipsum tempus donec lorem enim ut. Id lorem imperdiet blandit a cursus. Auctor malesuada tellus adipiscing habitasse porttitor egestas purus erat justo. `}</p>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BackgroundElementText;
